import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { MdClose, MdAdd } from "react-icons/md";
import { FaPlus } from "react-icons/fa";
import tw from "tailwind-styled-components";
import { Formik, Form } from "formik";
import {
    InputGroup,
    Label,
    SubmitBtn,
    SideCancelBtn,
    FieldWrappers,
    ModalHeader,
} from "../Styles/InputStyles";
import { toast } from "react-toastify";
import { ProfileSection } from "../Styles/PageStyles";
import moment from "moment";
import { useEffect, useState } from "react";
import axios from "axios";
import Config from "../../Config";
import { useSelector } from "react-redux";
import { capitalizeFirstLetter } from "../../helpers";
import { Link } from "react-router-dom";
import SelectOptionModal from "../SelectOptionModal";
import { useMutation } from "react-query";
import { TextareaAutosize } from "@mui/material";
import {
    MdPerson,
    MdCheck,
    MdComment,
} from "react-icons/md";

const ComplaintAction = ({
    handleClose,
    selectedData,
    assignComplaintLoading,
    assignComplaintMutate,
    updateComplaintLoading,
    updateComplaintMutate,
    activeTab,
    reOpenReason
}) => {
    const user = useSelector((state) => state.UserReducer.user);
    const selProperty = useSelector((state) => state.SelectPropertyReducer.selectProperty);
    const propId = selProperty.id;
    const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
    const [currentStatus, setCurrentStatus] = useState(selectedData?.status);
    const [remarks, setRemarks] = useState(selectedData?.remarks || "");
    const [showRemarkInput, setShowRemarkInput] = useState(false);
    const [remarkText, setRemarkText] = useState("");
    const [characterCount, setCharacterCount] = useState(0);
    const [showResolutionNote, setShowResolutionNote] = useState(false);
    const [resolutionNote, setResolutionNote] = useState(selectedData?.closingRemarks || "");
    const [resolutionCharCount, setResolutionCharCount] = useState(0);
    const [additionalAssignments, setAdditionalAssignments] = useState([]);
    const [selectedAdditionalId, setSelectedAdditionalId] = useState(null);
    const [editingField, setEditingField] = useState(null);
    const [staffRemarks, setStaffRemarks] = useState(selectedData?.staffRemarks || "");
    const [showCurrentSecondStaff, setShowCurrentSecondStaff] = useState(false);

    const getReopenReasonText = (reasonId) => {
        const reason = reOpenReason.find(r => r.id === reasonId);
        return reason ? `${reason.title}: ${reason.description}` : 'Unknown reason';
    };

    const initialValues = {
        name: selectedData?.raisedByName || "",
        propertyName: selectedData?.propertyName || "",
        status: selectedData?.status || "",
        assignedTo: selectedData?.assignedTo || "",
        staffNote: selectedData?.staffNote,
        staffRemarks: selectedData?.staffRemarks || "",
    };

    const query = `?propId=${propId}&filter=${1}?s`;
    const [selectedStatus, setSelectedStatus] = useState(
        selectedData?.status || ""
    );
    const [staffData, setStaffData] = useState([]);

    const fetchListing = async () => {
        try {
            const response = await axios.get(
                `${Config.apiUrl}/staff/list/web${query}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${user.token}`,
                    },
                }
            );
            setStaffData(response.data);
        } catch (error) {
            toast.error("Failed to fetch staff list");
        }
    };

    useEffect(() => {
        if (selectedStatus === Config.COMPLAINT_STATUS.ASSIGNED || (selectedData?.status === Config.COMPLAINT_STATUS.ASSIGNED && selectedStatus === Config.COMPLAINT_STATUS.ASSIGNED)) {
            fetchListing();
        }
    }, [selectedStatus]);

    useEffect(() => {
        if (selectedStatus === Config.COMPLAINT_STATUS.RESOLVED && selectedData?.status !== Config.COMPLAINT_STATUS.RESOLVED) {
            setShowResolutionNote(true);
        }
    }, [selectedStatus, selectedData?.status]);

    useEffect(() => {
        if (selectedData?.coAssignedTo || selectedData?.secondStaffName || selectedData?.secondStaffId) {
            setShowCurrentSecondStaff(true);
        }
    }, [selectedData?.coAssignedTo, selectedData?.secondStaffName, selectedData?.secondStaffId]);

    const handleResolutionNoteChange = (e) => {
        const text = e.target.value;
        if (text.length <= 500) {
            setResolutionNote(text);
            setResolutionCharCount(text.length);
        }
    }

    const getMainStaffId = (mainStaffId) => {
        if (!mainStaffId && selectedData?.assignedTo) {
            return selectedData.assignedTo;
        }
        return mainStaffId || null;
    };

    const getSecondStaffId = () => {
        if (additionalAssignments.length > 0 && additionalAssignments[0].value) {
            return additionalAssignments[0].value;
        }
        if (showCurrentSecondStaff) {
            return selectedData?.coAssignedTo || selectedData?.secondStaffId || null;
        }
        return null;
    };

    const handleSubmit = (values, { resetForm }) => {
        if (selectedStatus === Config.COMPLAINT_STATUS.PENDING) {
            updateComplaintMutate({
                status: selectedStatus,
                complaintId: selectedData?.id,
                complaintFor: selectedData?.raisedFor,
                assignedTo: null,
                closingRemarks: resolutionNote.trim(),
            });
            resetForm();
            return;
        }

        if (currentStatus === Config.COMPLAINT_STATUS.PENDING && selectedStatus !== Config.COMPLAINT_STATUS.ASSIGNED && selectedStatus !== Config.COMPLAINT_STATUS.RESOLVED) {
            toast.error("Please select a correct status value");
            return;
        }
        if (currentStatus === Config.COMPLAINT_STATUS.ASSIGNED && selectedStatus !== Config.COMPLAINT_STATUS.RESOLVED && selectedStatus !== Config.COMPLAINT_STATUS.ASSIGNED) {
            toast.error("Please select a correct status value");
            return;
        }
        if (selectedStatus === Config.COMPLAINT_STATUS.REOPENED) {
            updateComplaintMutate({
                status: selectedStatus,
                complaintId: selectedData?.id,
                complaintFor: selectedData?.raisedFor,
                assignedTo: null,
                closingRemarks: resolutionNote.trim(),
            });
            resetForm();
            return;
        }

        if (selectedStatus === Config.COMPLAINT_STATUS.ASSIGNED) {
            const mainStaffId = getMainStaffId(values.assignedTo);
            const secondStaffId = getSecondStaffId();

            if (!mainStaffId) {
                toast.error("Please select at least one staff to assign the complaint.");
                return;
            }

            const payload = {
                staffId: mainStaffId,
                complaintId: selectedData?.id,
                complaintFor: selectedData?.raisedFor,
                isReassignment: currentStatus === 2,
                closingRemarks: resolutionNote.trim(),
            };

            if (secondStaffId) {
                payload.secondStaffId = secondStaffId;
            }

            assignComplaintMutate(payload);
        } else if (selectedStatus === Config.COMPLAINT_STATUS.RESOLVED) {
            updateComplaintMutate({
                status: selectedStatus,
                complaintId: selectedData?.id,
                complaintFor: selectedData?.raisedFor,
                closingRemarks: resolutionNote.trim(),
            });
        }

        resetForm();
    };

    const getFilteredStaffOptions = (mainStaffId) => {
        return staffData?.data
            ?.filter(staff => staff.id !== mainStaffId)
            .map(staff => ({
                label: staff.name,
                value: staff.id,
            })) || [];
    };

    const staffOptions = staffData?.data?.map(staff => ({
        label: staff.name,
        value: staff.id,
    })) || [];

    const handleRemarkChange = (e) => {
        const text = e.target.value;
        if (text.length <= 500) {
            setRemarkText(text);
            setCharacterCount(text.length);
        }
    };

    const handleRemarkSubmit = async () => {
        if (!remarkText.trim()) {
            toast.error("Please enter a remark");
            return;
        }
        addNoteComplaintMutate({
            id: selectedData?.id,
            remarks: remarkText,
        });

    };

    const handleCancelRemark = () => {
        setRemarkText("");
        setCharacterCount(0);
        setShowRemarkInput(false);
    };

    const handleAddAssign = () => {
        if (additionalAssignments.length === 0) {
            if (showCurrentSecondStaff) {
                setShowCurrentSecondStaff(false);
            }
            setAdditionalAssignments([{ id: Date.now(), value: null }]);
        }
    };

    const handleRemoveAssign = (id) => {
        setAdditionalAssignments(additionalAssignments.filter(item => item.id !== id));
        if (selectedAdditionalId === id) {
            setSelectedAdditionalId(null);
        }
        if (additionalAssignments.length === 1) {
            setShowCurrentSecondStaff(false);
        }
    };

    const handleRemoveCurrentSecondStaff = () => {
        setShowCurrentSecondStaff(false);
        if (additionalAssignments.length > 0) {
            setAdditionalAssignments([]);
        }
    };

    const handleAdditionalStaffSelect = (id, selectedValue) => {
        setAdditionalAssignments(additionalAssignments.map(item =>
            item.id === id ? { ...item, value: selectedValue } : item
        ));
        setSelectedAdditionalId(null);
        setEditingField(null);
        if (showCurrentSecondStaff) {
            setShowCurrentSecondStaff(false);
        }
    };

    const openAdditionalModal = (id) => {
        setSelectedAdditionalId(id);
        setEditingField(id);
        setIsAssignModalOpen(true);
    };

    const openMainModal = () => {
        setSelectedAdditionalId(null);
        setEditingField('main');
        setIsAssignModalOpen(true);
    };

    const getAdditionalStaffName = (id) => {
        const item = additionalAssignments.find(a => a.id === id);
        if (!item || !item.value) return "Select Staff";
        const staff = staffData?.data?.find(s => s.id === item.value);
        return staff ? staff.name : "Select Staff";
    };

    const getMainStaffName = (mainStaffId) => {
        if (!mainStaffId) return "Select Staff";
        const staff = staffData?.data?.find(s => s.id === mainStaffId);
        return staff ? staff.name : "Select Staff";
    };

    const getCurrentAssignedStaffName = () => {
        if (!selectedData?.assignedTo) return "Select Staff";
        const staff = staffData?.data?.find(s => s.id === selectedData.assignedTo);
        return staff ? `${staff.name} (Current)` : "Select Staff";
    };

    const getCurrentSecondStaffName = () => {
        if (selectedData?.secondStaffName) {
            return selectedData.secondStaffName;
        }

        const staffId = selectedData?.coAssignedTo || selectedData?.secondStaffId;
        if (staffId && staffData?.data) {
            const staff = staffData?.data?.find(s => s.id === staffId);
            if (staff) return staff.name;
        }

        return null;
    };

    useEffect(() => {
        const staffId = selectedData?.coAssignedTo || selectedData?.secondStaffId;
        if (staffId && staffData?.data) {
            const existingSecondStaff = additionalAssignments.find(a => a.value === staffId);
            if (!existingSecondStaff && !showCurrentSecondStaff) {
                setAdditionalAssignments([{ id: Date.now(), value: staffId }]);
            }
        }
    }, [selectedData?.coAssignedTo, selectedData?.secondStaffId, selectedData?.secondStaffName, staffData?.data]);

    //------- Add Note Complaint Model -------
    const addNoteComplaintFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/complaint/edit/staffNote`, values, {
            headers: {
                "Content-Type": "application/json",
                authorization: `Bearer ${user.token}`,
            },
        });
    };

    const addNoteComplaintSuccess = (data) => {
        setRemarks(remarkText);
        setRemarkText("");
        setCharacterCount(0);
        setShowRemarkInput(false);
        toast.success(data?.data?.msg || "Remark added successfully!");
    };

    const addNoteComplaintError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occurred");
    };

    const { isLoading: addNoteComplaintLoading, mutate: addNoteComplaintMutate } =
        useMutation(addNoteComplaintFunction, {
            onSuccess: addNoteComplaintSuccess,
            onError: addNoteComplaintError,
        });


    return (
        <Container>
            <ModalHeader>
                <h1 className="text-white text-lg font-medium">Complaint Details</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>
            <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({ values, setFieldValue, resetForm }) => {
                    const getSelectedStaffName = () => {
                        if (!staffData?.data) return "Select Staff";

                        if (selectedData?.assignedTo && !values.assignedTo) {
                            return getCurrentAssignedStaffName();
                        }

                        return getMainStaffName(values.assignedTo);
                    };

                    const handleStaffSelect = (selectedValue) => {
                        if (selectedAdditionalId) {
                            handleAdditionalStaffSelect(selectedAdditionalId, selectedValue);
                        } else {
                            setFieldValue("assignedTo", selectedValue);
                        }
                        setEditingField(null);
                    };

                    const currentSecondStaffName = getCurrentSecondStaffName();

                    // Get filtered staff options for second staff (exclude main assigned)
                    const filteredStaffOptions = getFilteredStaffOptions(values.assignedTo || selectedData?.assignedTo);

                    return (
                        <Form>
                            <ScrollableContent className="max-h-[calc(100dvh-120px)]">
                                <ProfileSection>
                                    <UserInfo>
                                        <span className="font-medium">
                                            {capitalizeFirstLetter(selectedData.raisedByName)}
                                        </span>
                                        {activeTab === "1" &&
                                            <span className="text-sm text-gray-600">
                                                #{selectedData.roomNum},{" "}
                                                {selectedData.floor || selectedData.flatName},{" "}
                                                {selectedData.propertyName}
                                            </span>}
                                        {activeTab === "2" &&
                                            <span className="text-sm text-gray-600">
                                                #{selectedData.propertyName}
                                            </span>}
                                    </UserInfo>
                                </ProfileSection>
                                <Content>
                                    <ComplaintDetails>
                                        <div className="flex justify-between items-center">
                                            <SubTitle className="mb-0">{selectedData?.title}</SubTitle>
                                            <EditButton
                                                title={(remarks || selectedData?.staffNote) && !showRemarkInput ? "Edit Remark" : "Add Remark"}
                                                type="button"
                                                onClick={() => setShowRemarkInput(!showRemarkInput)}
                                            >
                                                {(remarks || selectedData?.staffNote) && !showRemarkInput ? "Edit Remark" : "Add Remark"}
                                            </EditButton>
                                        </div>
                                        <InfoText>{selectedData?.description}</InfoText>
                                    </ComplaintDetails>

                                    {showRemarkInput && (
                                        <div >
                                            <Label>Add Remark *</Label>
                                            <TextareaAutosize
                                                minRows={4}
                                                maxRows={6}
                                                value={remarkText}
                                                onChange={handleRemarkChange}
                                                placeholder="Enter your remark here (max 500 characters)"
                                                className="w-full p-3 border border-gray-300 rounded-md  resize-none mt-1"
                                                maxLength={500}
                                            />
                                            <div className="flex justify-between items-center mt-2">
                                                <span className={`text-sm ${characterCount === 500 ? 'text-red-500' : 'text-gray-500'}`}>
                                                    {characterCount}/500 characters
                                                </span>
                                                <div className="flex gap-2">
                                                    <button
                                                        type="button"
                                                        onClick={handleCancelRemark}
                                                        className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                                                    >
                                                        Cancel
                                                    </button>
                                                    <button
                                                        type="button"
                                                        onClick={handleRemarkSubmit}
                                                        disabled={addNoteComplaintLoading || !remarkText.trim()}
                                                        className={`px-4 py-2 text-sm font-medium text-white rounded-md  ${addNoteComplaintLoading || !remarkText.trim()
                                                            ? 'bg-primary-color/50 cursor-not-allowed'
                                                            : 'bg-primary-color'
                                                            }`}
                                                    >
                                                        {addNoteComplaintLoading ? 'Submitting...' : 'Submit'}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {(remarks || selectedData?.staffNote) && !showRemarkInput && (
                                        <div >
                                            <div className="flex justify-between items-center mb-1">
                                                <Label >Remark</Label>

                                            </div>
                                            <div className="bg-gray-50 px-4 py-2 rounded-md border border-gray-200">
                                                <InfoText>{remarks || selectedData?.staffNote}</InfoText>
                                            </div>
                                        </div>
                                    )}

                                    <Timeline>
                                        <SubTitle>Complaint History</SubTitle>

                                        <TimelineWrapper>
                                            {/* Complaint Raised */}
                                            <TimelineItem>
                                                <TimelineIndicator className="bg-blue-500">
                                                    <MdAdd />
                                                </TimelineIndicator>

                                                <TimelineContent>
                                                    <TimelineHeader>
                                                        <TimelineTitle>Complaint Raised</TimelineTitle>
                                                        <TimelineDate>
                                                            {moment(selectedData?.createdAt).format(
                                                                "DD MMM YYYY, hh:mm A"
                                                            )}
                                                        </TimelineDate>
                                                    </TimelineHeader>

                                                    <TimelineDescription>
                                                        Complaint raised by{" "}
                                                        <strong>{selectedData?.raisedByName}</strong>
                                                    </TimelineDescription>
                                                    {selectedData?.closingRemarks && selectedData?.status === Config.COMPLAINT_STATUS.PENDING &&
                                                        <TimelineContent>
                                                            <TimelineHeader>
                                                                <TimelineTitle>Notes</TimelineTitle>
                                                            </TimelineHeader>

                                                            <RemarkBox>
                                                                {selectedData?.closingRemarks}
                                                            </RemarkBox>
                                                        </TimelineContent>
                                                    }
                                                </TimelineContent>
                                            </TimelineItem>

                                            {/* Assigned */}
                                            {selectedData?.status === Config.COMPLAINT_STATUS.ASSIGNED && !selectedData?.resolvedAt && (
                                                <TimelineItem>
                                                    <TimelineIndicator className="bg-yellow-500">
                                                        <MdPerson />
                                                    </TimelineIndicator>

                                                    <TimelineContent>
                                                        <TimelineHeader>
                                                            <TimelineTitle>Complaint Assigned</TimelineTitle>
                                                            <TimelineDate>
                                                                {moment(selectedData?.updatedAt).format(
                                                                    "DD MMM YYYY, hh:mm A"
                                                                )}
                                                            </TimelineDate>
                                                        </TimelineHeader>

                                                        <TimelineDescription>
                                                            Assigned to{" "}
                                                            <strong>{selectedData?.staffName}</strong>
                                                            {selectedData?.secondStaffName && (
                                                                <> and <strong>{selectedData?.secondStaffName}</strong></>
                                                            )}
                                                        </TimelineDescription>
                                                        {selectedData?.closingRemarks &&
                                                            <TimelineContent>
                                                                <TimelineHeader>
                                                                    <TimelineTitle>Notes</TimelineTitle>
                                                                </TimelineHeader>

                                                                <RemarkBox>
                                                                    {selectedData?.closingRemarks}
                                                                </RemarkBox>
                                                            </TimelineContent>
                                                        }
                                                    </TimelineContent>
                                                </TimelineItem>
                                            )}

                                            {/* Resolved */}
                                            {selectedData?.resolvedAt && (
                                                <TimelineItem>
                                                    <TimelineIndicator className="bg-green-500">
                                                        <MdCheck />
                                                    </TimelineIndicator>

                                                    <TimelineContent>
                                                        <TimelineHeader>
                                                            <TimelineTitle>Complaint Resolved</TimelineTitle>
                                                            <TimelineDate>
                                                                {moment(selectedData?.resolvedAt).format(
                                                                    "DD MMM YYYY, hh:mm A"
                                                                )}
                                                            </TimelineDate>
                                                        </TimelineHeader>

                                                        <TimelineDescription>
                                                            Resolved by{" "}
                                                            <strong>{selectedData?.staffName}</strong>
                                                        </TimelineDescription>
                                                    </TimelineContent>
                                                </TimelineItem>
                                            )}

                                            {/* Closing Remark */}
                                            {selectedData?.status === Config.COMPLAINT_STATUS.RESOLVED &&
                                                selectedData?.closingRemarks && (
                                                    <TimelineItem>
                                                        <TimelineIndicator className="bg-gray-500">
                                                            <MdComment />
                                                        </TimelineIndicator>

                                                        <TimelineContent>
                                                            <TimelineHeader>
                                                                <TimelineTitle>Closing Remark</TimelineTitle>
                                                            </TimelineHeader>

                                                            <RemarkBox>
                                                                {selectedData?.closingRemarks}
                                                            </RemarkBox>
                                                        </TimelineContent>
                                                    </TimelineItem>
                                                )}
                                            {
                                                selectedData?.reopenReason &&
                                                moment(selectedData?.updatedAt).format("YYYY-MM-DD HH:mm:ss") !== moment(selectedData?.resolvedAt).format("YYYY-MM-DD HH:mm:ss") && (
                                                    <TimelineItem>
                                                        <TimelineIndicator className="bg-red-500">
                                                            <MdComment />
                                                        </TimelineIndicator>

                                                        <TimelineContent>
                                                            <TimelineHeader>
                                                                <TimelineTitle>Reopen Reason</TimelineTitle>
                                                            </TimelineHeader>

                                                            <RemarkBox className="bg-red-50 border-red-200">
                                                                {getReopenReasonText(selectedData?.reopenReason)}
                                                            </RemarkBox>
                                                        </TimelineContent>
                                                    </TimelineItem>
                                                )}
                                            {selectedData?.status === Config.COMPLAINT_STATUS.ASSIGNED &&
                                                moment(selectedData?.updatedAt).isAfter(
                                                    moment(selectedData?.resolvedAt)
                                                ) && (
                                                    <TimelineItem>
                                                        <TimelineIndicator className="bg-yellow-500">
                                                            <MdPerson />
                                                        </TimelineIndicator>

                                                        <TimelineContent>
                                                            <TimelineHeader>
                                                                <TimelineTitle>Complaint Assigned</TimelineTitle>

                                                                <TimelineDate>
                                                                    {moment(selectedData?.updatedAt).format(
                                                                        "DD MMM YYYY, hh:mm A"
                                                                    )}
                                                                </TimelineDate>
                                                            </TimelineHeader>

                                                            <TimelineDescription>
                                                                Assigned to{" "}
                                                                <strong>{selectedData?.staffName}</strong>
                                                                {selectedData?.secondStaffName && (
                                                                    <> and <strong>{selectedData?.secondStaffName}</strong></>
                                                                )}
                                                            </TimelineDescription>
                                                        </TimelineContent>
                                                    </TimelineItem>
                                                )}
                                        </TimelineWrapper>
                                    </Timeline>

                                    {selectedData?.status != Config.COMPLAINT_STATUS.RESOLVED && (
                                        <InputGroup>
                                            <Label>Status *</Label>
                                            <Select
                                                value={selectedStatus}
                                                onChange={(e) => {
                                                    const newStatus = e.target.value;
                                                    setSelectedStatus(newStatus);

                                                    if (newStatus === Config.COMPLAINT_STATUS.ASSIGNED) {
                                                        if (selectedData?.assignedTo) {
                                                            setFieldValue("assignedTo", selectedData.assignedTo);
                                                        }
                                                        else if (selectedData?.staffName) {
                                                            const staff = staffData?.data?.find(s => s.name === selectedData.staffName);
                                                            if (staff) {
                                                                setFieldValue("assignedTo", staff.id);
                                                            }
                                                        }
                                                    }
                                                    // Clear assignedTo when switching to other statuses
                                                    else if (newStatus !== Config.COMPLAINT_STATUS.ASSIGNED) {
                                                        setFieldValue("assignedTo", "");
                                                    }
                                                }}
                                                className="bg-white px-2 text-gray-600"
                                                style={{ height: "46px" }}
                                            >
                                                {(selectedData?.status == Config.COMPLAINT_STATUS.PENDING) && [
                                                    <MenuItem key={1} value={1}>
                                                        Pending
                                                    </MenuItem>,
                                                    <MenuItem key={2} value={2}>
                                                        Assigned
                                                    </MenuItem>,
                                                    <MenuItem key={3} value={3}>
                                                        Resolved
                                                    </MenuItem>,
                                                ]}
                                                {selectedData?.status == Config.COMPLAINT_STATUS.ASSIGNED && [
                                                    <MenuItem key={2} value={2}>
                                                        Assigned
                                                    </MenuItem>,
                                                    <MenuItem key={3} value={3}>
                                                        Resolved
                                                    </MenuItem>
                                                ]}
                                                {(selectedData?.status == Config.COMPLAINT_STATUS.REOPENED) && [
                                                    <MenuItem key={4} value={4}>
                                                        Reopened
                                                    </MenuItem>,
                                                    <MenuItem key={2} value={2}>
                                                        Assigned
                                                    </MenuItem>,
                                                    <MenuItem key={3} value={3}>
                                                        Resolved
                                                    </MenuItem>,
                                                ]}
                                            </Select>
                                        </InputGroup>
                                    )}

                                    {selectedStatus == Config.COMPLAINT_STATUS.ASSIGNED && staffData?.data?.length > 0 && (
                                        <>
                                            <InputGroup>
                                                <Label>{selectedData.status === Config.COMPLAINT_STATUS.ASSIGNED ? "Reassign To" : "Assign To"} *</Label>
                                                <FieldWrappers onClick={openMainModal}>
                                                    <input
                                                        type="text"
                                                        name="assignedTo"
                                                        autoComplete="off"
                                                        readOnly
                                                        value={getSelectedStaffName()}
                                                        className="w-full border-none outline-none bg-transparent cursor-pointer text-gray-600"
                                                        placeholder="Select staff"
                                                    />
                                                    <IconWrapper>
                                                        <FaPlus className="w-3 h-3" />
                                                    </IconWrapper>
                                                </FieldWrappers>
                                                {selectedData.status === Config.COMPLAINT_STATUS.ASSIGNED && selectedData.assignedTo && (
                                                    <p className="text-sm text-gray-500 mt-1">
                                                        Currently assigned to: {selectedData.staffName}
                                                        {selectedData?.secondStaffName && (
                                                            <> and {selectedData?.secondStaffName}</>
                                                        )}
                                                    </p>
                                                )}

                                                {/* Show current second staff with remove option */}
                                                {showCurrentSecondStaff && currentSecondStaffName && additionalAssignments.length === 0 && (
                                                    <AdditionalAssignWrapper>
                                                        <InputGroup>
                                                            <Label>Second Staff (Current)</Label>
                                                            <FieldWrappers>
                                                                <input
                                                                    type="text"
                                                                    autoComplete="off"
                                                                    readOnly
                                                                    value={currentSecondStaffName}
                                                                    className="w-full border-none outline-none bg-transparent text-gray-600"
                                                                    placeholder="Select staff"
                                                                />
                                                                <RemoveButton
                                                                    type="button"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleRemoveCurrentSecondStaff();
                                                                    }}
                                                                    title="Remove second staff"
                                                                >
                                                                    <FaPlus className="w-3 h-3 rotate-45" />
                                                                </RemoveButton>
                                                            </FieldWrappers>
                                                        </InputGroup>
                                                    </AdditionalAssignWrapper>
                                                )}

                                                {/* Add button - only show if no current second staff and no additional assignments */}
                                                {!showCurrentSecondStaff && additionalAssignments.length === 0 && (
                                                    <AddButtonWrapper>
                                                        <AddButton
                                                            type="button"
                                                            onClick={handleAddAssign}
                                                        >
                                                            <MdAdd className="mr-1" size={16} />
                                                            Assign Second Staff
                                                        </AddButton>
                                                    </AddButtonWrapper>
                                                )}
                                            </InputGroup>

                                            {/* Additional assignment fields */}
                                            {additionalAssignments.map((item) => (
                                                <AdditionalAssignWrapper key={item.id}>
                                                    <InputGroup>
                                                        <Label>Second Staff</Label>
                                                        <FieldWrappers onClick={() => openAdditionalModal(item.id)}>
                                                            <input
                                                                type="text"
                                                                autoComplete="off"
                                                                readOnly
                                                                value={getAdditionalStaffName(item.id)}
                                                                className="w-full border-none outline-none bg-transparent cursor-pointer text-gray-600"
                                                                placeholder="Select staff"
                                                            />
                                                            <RemoveButton
                                                                type="button"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleRemoveAssign(item.id);
                                                                }}
                                                            >
                                                                <FaPlus className="w-3 h-3 rotate-45" />
                                                            </RemoveButton>
                                                        </FieldWrappers>
                                                    </InputGroup>
                                                </AdditionalAssignWrapper>
                                            ))}
                                        </>
                                    )}

                                    {selectedData?.status !== Config.COMPLAINT_STATUS.RESOLVED && (
                                        <div>
                                            <Label> Notes </Label>
                                            <TextareaAutosize
                                                minRows={3}
                                                maxRows={5}
                                                value={resolutionNote}
                                                onChange={handleResolutionNoteChange}
                                                placeholder="Please provide detailed notes (e.g., what was done to resolve the complaint, any follow-up actions, etc.)"
                                                className="w-full p-3 border border-gray-300 rounded-md resize-none mt-1"
                                                maxLength={500}
                                            />
                                            <div className="flex justify-between items-center mt-2">
                                                <span className={`text-sm ${resolutionCharCount === 500 ? 'text-red-500' : 'text-gray-500'}`}>
                                                    {resolutionCharCount}/500 characters
                                                </span>
                                            </div>
                                        </div>
                                    )}

                                    {selectedData?.img &&
                                        <div className="flex justify-end">
                                            <FlexCol>
                                                <Value className="text-blue-300 underline">
                                                    <Link
                                                        to={selectedData?.img}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {selectedData?.img?.split("/").pop()}
                                                    </Link>
                                                </Value>
                                            </FlexCol>
                                        </div>
                                    }
                                </Content>
                            </ScrollableContent>
                            {selectedData.status != Config.COMPLAINT_STATUS.RESOLVED &&
                                <ActionSection>
                                    <SideCancelBtn type="button" onClick={() => {
                                        resetForm();
                                        handleClose();
                                    }}>
                                        Cancel
                                    </SideCancelBtn>
                                    <SubmitBtn
                                        type="submit"
                                        disabled={assignComplaintLoading || updateComplaintLoading}
                                    >
                                        {assignComplaintLoading || updateComplaintLoading ?
                                            "Loading..." :
                                            selectedData.status === Config.COMPLAINT_STATUS.ASSIGNED && selectedStatus === Config.COMPLAINT_STATUS.ASSIGNED ?
                                                "Reassign" :
                                                "Submit"}
                                    </SubmitBtn>
                                </ActionSection>}
                            <SelectOptionModal
                                isOpen={isAssignModalOpen}
                                onClose={() => {
                                    setIsAssignModalOpen(false);
                                    setSelectedAdditionalId(null);
                                    setEditingField(null);
                                }}
                                title={
                                    editingField === 'main'
                                        ? (selectedData.status === Config.COMPLAINT_STATUS.ASSIGNED ? "Select New Staff" : "Select Staff")
                                        : "Select Staff"
                                }
                                options={editingField === 'main' ? staffOptions : filteredStaffOptions}
                                selectedValue={selectedAdditionalId ?
                                    additionalAssignments.find(a => a.id === selectedAdditionalId)?.value || null :
                                    values.assignedTo
                                }
                                onSelect={(selectedValue) => handleStaffSelect(selectedValue)}
                                searchPlaceholder="Search staff..."
                            />
                        </Form>
                    )
                }}
            </Formik>
        </Container>
    );
};

const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
const Header = tw.div`flex items-center justify-between bg-[#0078BD] py-4 px-4`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-white`;
const ScrollableContent = tw.div`flex-grow overflow-y-auto max-h-[calc(100vh-100px)] pb-4`;
const Content = tw.div`p-4 flex flex-col gap-4`;
const SubTitle = tw.h3`text-base font-medium mb-2 text-gray-600`;
const InfoText = tw.h3`text-sm text-gray-400 leading-relaxed break-words whitespace-pre-wrap`;
const UserInfo = tw.div`flex flex-col`;
const ComplaintDetails = tw.div`flex flex-col gap-2`;
const ActionSection = tw.div`p-4 bg-white flex justify-between border-t border-gray-200 absolute bottom-0 left-0 w-full`;
const FlexCol = tw.div`flex flex-col gap-0.5`;
const Value = tw.span`text-gray-600 text-md`;
const IconWrapper = tw.div`mr-2 flex-shrink-0 p-2 rounded-lg transition-all duration-300 bg-gray-100 text-gray-600`;
const EditButton = tw.button` text-sm px-1 py-0.5 items-center flex justify-between text-primary-color underline`;

const Timeline = tw.div`
    flex
    flex-col
`;

const TimelineWrapper = tw.div`
    relative
    mt-2
    ml-1
`;

const TimelineItem = tw.div`
    relative
    flex
    items-start
    gap-4
    pb-6
    last:pb-0
`;

const TimelineIndicator = tw.div`
    relative
    z-10
    flex
    items-center
    justify-center
    w-8
    h-8
    min-w-[32px]
    rounded-full
    text-white
    text-sm

    after:content-['']
    after:absolute
    after:top-8
    after:left-1/2
    after:-translate-x-1/2
    after:w-px
    after:h-[calc(100%)]
    after:bg-gray-200
    last:after:hidden
`;

const TimelineContent = tw.div`
    flex
    flex-col
    flex-1
    min-w-0
    pt-0.5
`;

const TimelineHeader = tw.div`
    flex
    items-center
    justify-between
    gap-3
    flex-wrap
`;

const TimelineTitle = tw.p`
    text-sm
    font-semibold
    text-gray-800
`;

const TimelineDate = tw.span`
    text-xs
    text-gray-400
    whitespace-nowrap
`;

const TimelineDescription = tw.p`
    mt-1
    text-sm
    text-gray-600
`;

const RemarkBox = tw.div`
    mt-2
    rounded-md
    bg-gray-50
    border
    border-gray-200
    px-3
    py-2
    text-sm
    text-gray-600
    break-words
`;

const AddButtonWrapper = tw.div`
    flex
    justify-end
    mt-1
`;

const AddButton = tw.button`
    flex
    items-center
    text-sm
    text-primary-color
    hover:text-primary-color/80
    transition-colors
    duration-200
    font-medium
`;

const AdditionalAssignWrapper = tw.div`
    mt-2
`;

const RemoveButton = tw.button`
    mr-2
    flex-shrink-0
    p-2
    hover:text-red-500
    duration-200 rounded-lg transition-all duration-300 bg-gray-100 text-gray-600
`;

export default ComplaintAction;